// ===========================================
// TRÄNINGSPROGRAM - Optimerade för max 60 minuter
// ===========================================
const PROGRAMS = [
  {
    id: 'fullbody3x',
    title: 'Helkropp 3x/vecka',
    subtitle: 'För nybörjare & återkomlare',
    frequency: 3,
    duration: '50-60 min',
    level: 'Nybörjare-Medel',
    description: 'Träna hela kroppen varje pass. Vila minst en dag mellan passen. Perfekt för att bygga en solid grund.',
    schedule: 'Måndag • Onsdag • Fredag',
    days: [
      {
        name: 'Pass A',
        exercises: [
          { id: 'squat', sets: 3, reps: '8-10', rest: '90 sek' },
          { id: 'benchPress', sets: 3, reps: '8-10', rest: '90 sek' },
          { id: 'barbellRow', sets: 3, reps: '8-10', rest: '90 sek' },
          { id: 'overheadPress', sets: 3, reps: '10-12', rest: '60 sek' },
          { id: 'latPulldown', sets: 3, reps: '10-12', rest: '60 sek' },
          { id: 'gluteBridge', sets: 3, reps: '12-15', rest: '45 sek' },
          { id: 'plank', sets: 2, reps: '45 sek', rest: '45 sek' },
        ]
      },
      {
        name: 'Pass B',
        exercises: [
          { id: 'romanianDeadlift', sets: 3, reps: '8-10', rest: '90 sek' },
          { id: 'inclineBenchPress', sets: 3, reps: '10-12', rest: '90 sek' },
          { id: 'seatedRow', sets: 3, reps: '10-12', rest: '90 sek' },
          { id: 'lunge', sets: 3, reps: '10/ben', rest: '60 sek' },
          { id: 'lateralRaise', sets: 3, reps: '12-15', rest: '45 sek' },
          { id: 'facePull', sets: 3, reps: '15-20', rest: '45 sek' },
          { id: 'crunch', sets: 2, reps: '15-20', rest: '45 sek' },
        ]
      },
    ]
  },
  {
    id: 'upperLower4x',
    title: 'Överkropp/Underkropp 4x',
    subtitle: 'Balanserad split',
    frequency: 4,
    duration: '55-60 min',
    level: 'Medel',
    description: 'Dela upp kroppen i överkropp och underkropp. Varje muskel tränas 2 gånger i veckan.',
    schedule: 'Mån: Överkropp • Tis: Underkropp • Tor: Överkropp • Fre: Underkropp',
    days: [
      {
        name: 'Överkropp A (Styrka)',
        exercises: [
          { id: 'benchPress', sets: 4, reps: '6-8', rest: '2 min' },
          { id: 'barbellRow', sets: 4, reps: '6-8', rest: '2 min' },
          { id: 'overheadPress', sets: 3, reps: '8-10', rest: '90 sek' },
          { id: 'latPulldown', sets: 3, reps: '10-12', rest: '60 sek' },
          { id: 'chestFly', sets: 3, reps: '12-15', rest: '45 sek' },
          { id: 'facePull', sets: 3, reps: '15-20', rest: '45 sek' },
          { id: 'bicepCurl', sets: 3, reps: '10-12', rest: '45 sek' },
          { id: 'tricepPushdown', sets: 3, reps: '10-12', rest: '45 sek' },
        ]
      },
      {
        name: 'Underkropp A (Styrka)',
        exercises: [
          { id: 'squat', sets: 4, reps: '6-8', rest: '2 min' },
          { id: 'romanianDeadlift', sets: 3, reps: '8-10', rest: '2 min' },
          { id: 'legPress', sets: 3, reps: '10-12', rest: '90 sek' },
          { id: 'legCurl', sets: 3, reps: '10-12', rest: '60 sek' },
          { id: 'legExtension', sets: 3, reps: '12-15', rest: '60 sek' },
          { id: 'gluteBridge', sets: 3, reps: '12-15', rest: '45 sek' },
          { id: 'calfRaise', sets: 4, reps: '12-15', rest: '45 sek' },
          { id: 'plank', sets: 3, reps: '45 sek', rest: '45 sek' },
        ]
      },
      {
        name: 'Överkropp B (Volym)',
        exercises: [
          { id: 'inclineBenchPress', sets: 3, reps: '8-10', rest: '90 sek' },
          { id: 'seatedRow', sets: 3, reps: '8-10', rest: '90 sek' },
          { id: 'dips', sets: 3, reps: '8-12', rest: '60 sek' },
          { id: 'pullUp', sets: 3, reps: '6-10', rest: '60 sek' },
          { id: 'lateralRaise', sets: 3, reps: '12-15', rest: '45 sek' },
          { id: 'rearDeltFly', sets: 3, reps: '15-20', rest: '45 sek' },
          { id: 'hammerCurl', sets: 3, reps: '10-12', rest: '45 sek' },
          { id: 'tricepExtension', sets: 3, reps: '10-12', rest: '45 sek' },
        ]
      },
      {
        name: 'Underkropp B (Volym)',
        exercises: [
          { id: 'hipThrust', sets: 4, reps: '10-12', rest: '90 sek' },
          { id: 'bulgarianSplitSquat', sets: 3, reps: '10/ben', rest: '90 sek' },
          { id: 'legPress', sets: 3, reps: '12-15', rest: '60 sek' },
          { id: 'legCurl', sets: 3, reps: '10-12', rest: '60 sek' },
          { id: 'legExtension', sets: 3, reps: '12-15', rest: '60 sek' },
          { id: 'gluteBridge', sets: 3, reps: '15-20', rest: '45 sek' },
          { id: 'calfRaise', sets: 4, reps: '15-20', rest: '45 sek' },
          { id: 'russianTwist', sets: 3, reps: '15/sida', rest: '45 sek' },
        ]
      }
    ]
  },
  {
    id: 'ppl5x',
    title: 'Push/Pull/Ben 5x',
    subtitle: 'För erfarna tränare',
    frequency: 5,
    duration: '55-60 min',
    level: 'Avancerad',
    description: 'Klassisk split för seriös muskeltillväxt. Effektiva pass med hög intensitet.',
    schedule: 'Mån: Push • Tis: Pull • Ons: Ben • Fre: Push • Lör: Pull/Ben',
    days: [
      {
        name: 'Push (Bröst, Axlar, Triceps)',
        exercises: [
          { id: 'benchPress', sets: 4, reps: '6-8', rest: '2 min' },
          { id: 'inclineBenchPress', sets: 3, reps: '8-10', rest: '90 sek' },
          { id: 'overheadPress', sets: 3, reps: '8-10', rest: '90 sek' },
          { id: 'dips', sets: 3, reps: '8-12', rest: '60 sek' },
          { id: 'chestFly', sets: 3, reps: '12-15', rest: '45 sek' },
          { id: 'lateralRaise', sets: 3, reps: '12-15', rest: '45 sek' },
          { id: 'tricepPushdown', sets: 3, reps: '10-12', rest: '45 sek' },
          { id: 'tricepExtension', sets: 3, reps: '10-12', rest: '45 sek' },
        ]
      },
      {
        name: 'Pull (Rygg, Biceps)',
        exercises: [
          { id: 'barbellRow', sets: 4, reps: '6-8', rest: '2 min' },
          { id: 'latPulldown', sets: 3, reps: '8-10', rest: '90 sek' },
          { id: 'seatedRow', sets: 3, reps: '10-12', rest: '60 sek' },
          { id: 'pullUp', sets: 3, reps: '6-10', rest: '60 sek' },
          { id: 'dumbbellRow', sets: 3, reps: '10-12', rest: '60 sek' },
          { id: 'facePull', sets: 3, reps: '15-20', rest: '45 sek' },
          { id: 'bicepCurl', sets: 3, reps: '10-12', rest: '45 sek' },
          { id: 'hammerCurl', sets: 3, reps: '10-12', rest: '45 sek' },
        ]
      },
      {
        name: 'Ben (Lår, Rumpa, Vader)',
        exercises: [
          { id: 'squat', sets: 4, reps: '6-8', rest: '2 min' },
          { id: 'romanianDeadlift', sets: 3, reps: '8-10', rest: '2 min' },
          { id: 'hipThrust', sets: 3, reps: '10-12', rest: '90 sek' },
          { id: 'legPress', sets: 3, reps: '10-12', rest: '90 sek' },
          { id: 'bulgarianSplitSquat', sets: 3, reps: '10/ben', rest: '60 sek' },
          { id: 'legCurl', sets: 3, reps: '10-12', rest: '60 sek' },
          { id: 'legExtension', sets: 3, reps: '12-15', rest: '60 sek' },
          { id: 'gluteBridge', sets: 3, reps: '12-15', rest: '45 sek' },
          { id: 'calfRaise', sets: 4, reps: '12-15', rest: '45 sek' },
          { id: 'plank', sets: 3, reps: '45 sek', rest: '45 sek' },
        ]
      },
    ]
  }
];

export { PROGRAMS };
